import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@assets/scss/index.scss';
// import './iconfont.css';
import { ApolloProvider } from "@apollo/client";
import { Locale } from '@common/constans';
// import * as serviceWorker from './serviceWorker';
import { IGResponse } from '@common/models';
import { ICultureSetting, IMenuItem, ISetting, IVocab } from '@common/models/CMS';
import { appConfig, IAppConfig } from '@config/appConfig';
import UnderMaintenance from '@pages/UnderMaintenance';
import Config from '@service/Config';
import { apolloQuery, GET_CULTURE, GET_MENU, GET_SETTING, GET_VOCAB, getApolloClient, setApolloClient } from "@service/graphql";
import Splash from '@service/Splash';
import { loadLocale, setDefaultAttribute } from '@utilize/Init';
import { getSizingDefaultValues } from '@utilize/Util';
import ReactDOM from 'react-dom';
import App from './App';
import { Culture, IrDate, IVocabs, mapCmsLocateToLocale, UsDate } from './core';
import reportWebVitals from './reportWebVitals';

// ahow splash plugin
Splash.show();
// get app config form server
fetch(`${process.env.NODE_ENV === "development" ? appConfig.basePath : ""}/api/client/setting`)
  .then((response) => response.json())
  .then((result) => {
    const config: IAppConfig = result;
    Config.init(Object.assign(appConfig, config));
    Config.config.typography = {
      defaultPadding: getSizingDefaultValues()
    };
    setApolloClient(Config.config.contentApi || "");
    // Analytics.init(Config.config.gAnalyticsCode);
    return apolloQuery<IGResponse<ISetting[]>>(GET_SETTING);
  })
  .then((response) => {
    // set setting
    const setting = response.data.setting[0];
    Config.set('setting', setting);
    if (Config.config.setting.underMaintenanceUntil && new Date(Config.config.setting.underMaintenanceUntil).getTime() > new Date().getTime()) {
      ReactDOM.render(
        <UnderMaintenance />,
        document.getElementById('root')
      );
    } else {
      startApp();
    }
  })
  .catch((err) => {
    Splash.error();
    console.log(err);
  });

function startApp() {
  apolloQuery<IGResponse<ICultureSetting[]>>(GET_CULTURE)
    .then((response) => {
      // initiating locale
      const cultureSettings = response.data.cultureSetting;
      cultureSettings.forEach(cs => {
        const locale = mapCmsLocateToLocale(cs);
        Culture.register(locale, locale.code === Locale.fa ? IrDate : UsDate);
      })
      loadLocale();
      setDefaultAttribute();
      return apolloQuery<IGResponse<IVocab[]>>(GET_VOCAB);
    })
    .then((response) => {
      // set vocab
      const vocab: IVocabs = {};
      const vocabs: IVocab[] = response.data.vocab;
      vocabs.forEach(v => Object.assign(vocab, { [v.key]: v.value }));
      Culture.setVocabs(Culture.getLocale().code, vocab);
      return apolloQuery<IGResponse<IMenuItem[]>>(GET_MENU);
    })
    .then((response) => {
      ReactDOM.render(
        <ApolloProvider client={getApolloClient()}>
          <App menu={response?.data.menu} />
        </ApolloProvider>,
        document.getElementById('root')
      );

      // If you want your app to work offline and load faster, you can change
      // unregister() to register() below. Note this comes with some pitfalls.
      // Learn more about service workers: https://bit.ly/CRA-PWA
      // serviceWorker.unregister();

      // If you want to start measuring performance in your app, pass a function
      // to log results (for example: reportWebVitals(console.log))
      // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
      reportWebVitals();
    })
    .catch((err) => {
      Splash.error();
      console.log(err);
    });
}



